import { IPatient, PatientStateType } from "@/api/dtos";
import { IInstitution, PatientSummaryManager } from "@ngt/opms";
import { JsonServiceClient } from "@servicestack/client";
import { useSnackbar } from "notistack";
import { useMemo } from "react";


// const hideBaselineActions = (actionPatient: IPatient | null | undefined) => actionPatient != null;
// const hideCycle2Actions = (actionPatient: IPatient | null | undefined) => actionPatient?.patientStateId != PatientStateType.Baseline;
// const hideCycle3Actions = (actionPatient: IPatient | null | undefined) => actionPatient?.patientStateId != PatientStateType.Cycle2;
// const hideEndOfTreatmentActions = (actionPatient: IPatient | null | undefined) => actionPatient?.patientStateId == PatientStateType.EndOfTreatment || actionPatient?.patientStateId == PatientStateType.Withdrawn;

const usePatientSummaryEventActions = (
    _saving: boolean,
    _updatePatientState: (state: PatientStateType, skipPatientEmail: boolean, patientStatusReason?: string) => void,
    _enqueueSnackbar: ReturnType<typeof useSnackbar>['enqueueSnackbar'],
    _client: JsonServiceClient,
    _patient: IPatient | null | undefined,
    _patientValid: boolean,
    _institution: IInstitution | null | undefined,
    _canUpdatePatient: boolean | undefined,
    _manager: PatientSummaryManager | undefined
) => {
    const eventActionMapping = useMemo(() => ({
        // return {
        //     'baseline': baselineActions,
        //     'cycle-2-visit': cycle2Actions,
        //     'cycle-3-visit': cycle3Actions,
        //     'end-of-treatment-visit': endOfTreatmentActions
        // };
    }), []);

    return eventActionMapping;
}

export default usePatientSummaryEventActions;